import styled from 'styled-components';

export const ArticleSection = styled.section`
  margin-bottom: 2.5rem;

  &:first-of-type {
    margin-top: 1rem;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-align: right;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ArticleText = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  text-align: right;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const List = styled.ul`
  padding-right: 1.5rem;
  margin-bottom: 1.5rem;
  direction: rtl;
`;

export const ListItem = styled.li`
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const BackButtonWrapper = styled.div`
  position: absolute;
  top: 120px;
  right: 2rem;
  z-index: 10;

  button {
    background-color: rgba(255, 255, 255, 0.9);
    padding: 0.8rem 1.2rem;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    box-shadow: ${({ theme }) => theme.shadows.medium};
    font-size: 1.1rem;
    transition: all 0.2s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.white};
      transform: translateX(5px);
    }
  }
`;

export const ImageTextSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  margin-bottom: 2.5rem;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const SectionImage = styled.img`
  width: 45%;
  height: auto;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  object-fit: cover;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const TextContent = styled.div`
  flex: 1;
  text-align: right;
`;
